import React from 'react';
import {withTranslation} from "react-i18next";

const TenBisPayment = ({ t, setCardData }) => {

  const onChangeCardNumber = (e) => {
    const { value } = e.currentTarget;
    setCardData({cardNumber: value});
  };

  return (
    <div className={'payment-block ten-bis-payment'}>
      <div className={'payment-content'} >
        <form className={'card-form'} onSubmit={ ()=> {}}>
          <div className={'form-input required'}>
            <label htmlFor='cardNumber'>{ t('payment.card_number') }</label>
            <input type='number' name='cardNumber'  placeholder={t('payment.card_number')} onChange={ onChangeCardNumber } />
          </div>
        </form>
      </div>
    </div>
  );
};

export default withTranslation()(TenBisPayment);
